// extracted by mini-css-extract-plugin
export default {"container":"src-components-Gallery--container","container__block":"src-components-Gallery--container__block","container__image":"src-components-Gallery--container__image"};